const about_url='/prod-api/api/about/about.detail';
const customer_url='/prod-api/api/about/customer';
const login_url='/prod-api/api/login/login.do';
const sendSMS_url='/prod-api/api/sms/sendSMS';
const resetPwd_url='/prod-api/api/safe/resetPassword.do'
const personal_detail='/prod-api/api/personal/personal.detail'   //个人信息
const messageRemind_messageRemindList='/prod-api/api/messageRemind/messageRemindList'  //当前用户的消息列表
const messageRemind_editReadStatus='/prod-api/api/messageRemind/editReadStatus'  //将未读的消息状态改为已读
const notcice_url='/prod-api/api/notices/notices.list' //系统公告
const notciceDetail_url='/prod-api/api/notices/notices.id'  //系统公告详情
const news_classify='/prod-api/api/classify/classify.list'   //新闻分类
const news_list='/prod-api/api/news/news.list'   //新闻列表
const new_detail='/prod-api/api/news/news.detail' //新闻详情
const comments_list='/prod-api/api/comments/comments.list'   //新闻评论
const comments_comments='/prod-api/api/comments/comments.submit' //提交资讯评论
const questions_handpickQuestionsList='/prod-api/api/questions/questions.handpickQuestionsList'   //精选答疑列表
const questions_detail='/prod-api/api/questions/questions.detail'  //答疑详情
const questions_list='/prod-api/api/questions/questions.list'  //我的答疑
const questions_submit='/prod-api/api/questions/questions.submit'  //提交答疑
const banners_bannersList='/prod-api/api/banners/bannersList'   //banner列表
const categorys_oneClassifyDescription='/prod-api/api/categorys/oneClassifyDescription'  //pc端 首页一级分类的介绍
const categorys_twoClassify='/prod-api/api/categorys/twoClassify'   //pc端 首页根据一级分类ID查询二级
const categorys_description='/prod-api/api/categorys/description'  //pc端 首页根据ID 查询详情
const about_liveCourse='/prod-api/api/about/liveCourse'   //直播课列表
const testPaper_testPaperList='/prod-api/api/testPaper/testPaperList'  //历年真题 或 模拟考试的列表
const testPaper_exercisesList='/prod-api/api/testPaper/exercisesList'   //练习题的列表
const testPaper_testPaperQuestionList='/prod-api/api/testPaper/testPaperQuestionList'   //历年真题 或 模拟考试的 若干个题列表
const testPaper_selectTestQuestionListByPageSize='/prod-api/api/testPaper/selectTestQuestionListByPageSize'   //根据试卷的id和数量查询题的列表
const testPaper_removeCollQuestion='/prod-api/api/testPaper/removeCollQuestion'   //questionId 题干id   errorQuestionStatus   1:历年真题 2：模拟考试 3：课后练习4：综合通关 5：考点练习
const testPaper_testPaperDetail='/prod-api/api/testPaper/testPaperDetail'   //历年真题 或 模拟考试的详情
const personal_statisticsSub='/prod-api/api/personal/statisticsSub'   //统计提交
const testPaper_testPaperQuestionSub='/prod-api/api/testPaper/testPaperQuestionSub'//1:历年真题 2：模拟考试 3：课后练习4：综合通关 5：考点练习 试题提交
const testPaper_selectQuestionsCountByAccountId='/prod-api/api/testPaper/selectQuestionsCountByAccountId'   //根据用户id查询各个类型答题的数量及正确率
const login_bugTag='/prod-api/api/login/bugTag'   //查询用户是否购买过考试
const serviceTime_newServiceTimeList='/prod-api/api/serviceTime/newServiceTimeList'  //服务时间列表
const login_accountCategory='/prod-api/api/login/accountCategory.update' //用户选择考试类型
const purchaseServiceFormOrder_buyServiceForm='/prod-api/api/purchaseServiceFormOrder/pcBuyServiceForm'   //购买服务
const testPaper_sundryErrorQuestionCount='/prod-api/api/testPaper/sundryErrorQuestionCount'   //错题合集汇总
const testPaper_sundryErrorQuestionList='/prod-api/api/testPaper/sundryErrorQuestionList'   //各个类型的错题列表
const testPaper_removeErrorQuestion='/prod-api/api/testPaper/removeErrorQuestion'  //移除错题
const upload_url='/prod-api/app/upload'  //移除错题
const opinion_submit='/prod-api/api/opinion/opinion.submit'   //提交意见反馈
const questions_studentReply='/prod-api/api/questions/studentReply'   //学生回复
const questions_answerQuestionsReplyList='/prod-api/api/questions/answerQuestionsReplyList'  //答疑回复列表
const testPaper_sundryCollQuestionCount='/prod-api/api/testPaper/sundryCollQuestionCount'    //收藏题合集汇总
const testPaper_sundryCollQuestionList='/prod-api/api/testPaper/sundryCollQuestionList'   //各个类型的收藏题列表    //1:历年真题 2：模拟考试 3：课后练习4：综合通关 5：考点练习
const temporaryStorageSub_url='/prod-api/api/testPaper/temporaryStorageSub'  //暂存
const temporaryStorage_url='/prod-api/api/testPaper/temporaryStorage'   //获取暂存数据
const answerAnalysisSub_url='/prod-api/api/testPaper/answerAnalysisSub' //缓存解析
const answerAnalysis_url='/prod-api/api/testPaper/answerAnalysis'  //获取解析
const testPaper_testQuestionCacheSub='/prod-api/api/testPaper/testQuestionCacheSub'  //答题缓存提交
const testPaper_selectTestQuestionCache='/prod-api/api/testPaper/selectTestQuestionCache'  //testQuestionsId 试卷ID
const questionComment_sub='/prod-api/api/questionComment/sub'
const questionComment_index='/prod-api/api/questionComment/index'
const questionErrorCorrection_sub='/prod-api/api/questionErrorCorrection/sub'   //题纠错提交
const questionNote_sub='/prod-api/api/questionNote/sub'   //题笔记提交
const questionNote_index='/prod-api/api/questionNote/index'   //题笔记列表
const testPaper_appExercisesList='/prod-api/api/testPaper/appExercisesList'
const testPaper_appTestExercisesList='/prod-api/api/testPaper/appTestExercisesList'
const testPaper_newSundryCollQuestionList='/prod-api/api/testPaper/newSundryCollQuestionList'
const testPaper_sundryTestErrorQuestionList='/prod-api/api/testPaper/sundryTestErrorQuestionList'
const testPaper_newRemoveCollQuestion='/prod-api/api/testPaper/newRemoveCollQuestion'
const testPaper_newRemoveErrorQuestion='/prod-api/api/testPaper/newRemoveErrorQuestion'
const pictures_picturesCategoryList='/prod-api/api/pictures/picturesCategoryList.page'
const pictures_pictureList='/prod-api/api/pictures/pictureList.page'
const vocationalExam_examGraduateStudentCategoryList='/prod-api/api/examGraduateStudent/examGraduateStudentCategoryList.page'
const pcCover_getPcCoverById='/prod-api/api/pcCover/getPcCoverById'
const examGraduateStudent_examGraduateStudentList='/prod-api/api/examGraduateStudent/examGraduateStudentList.page'
const vocationalExam_vocationalExamCategoryList='/prod-api/api/vocationalExam/vocationalExamCategoryList.page'
const vocationalExam_vocationalExamList='/prod-api/api/vocationalExam/vocationalExamList.page'
const purchaseServiceFormOrder_serviceFormByOrderId='/prod-api/api/purchaseServiceFormOrder/serviceFormByOrderId'
const categoryListSon_url='/prod-api/api/common/categoryList.son';
const login_selectCategory='/prod-api/api/login/selectCategory';
const HTTP_REQUEST_URL=''
export default {
    about_url,
    customer_url,
    login_url,
    sendSMS_url,
    resetPwd_url,
    personal_detail,
    messageRemind_messageRemindList,
    messageRemind_editReadStatus,
    notciceDetail_url,
    notcice_url,
    news_classify,
    news_list,
    new_detail,
    comments_list,
    comments_comments,
    questions_handpickQuestionsList,
    questions_detail,
    questions_list,
    questions_submit,
    banners_bannersList,
    categorys_oneClassifyDescription,
    categorys_twoClassify,
    categorys_description,
    about_liveCourse,
    testPaper_testPaperList,
    testPaper_exercisesList,
    testPaper_testPaperQuestionList,
    testPaper_selectTestQuestionListByPageSize,
    testPaper_removeCollQuestion,
    testPaper_testPaperDetail,
    personal_statisticsSub,
    testPaper_testPaperQuestionSub,
    testPaper_selectQuestionsCountByAccountId,
    login_bugTag,
    serviceTime_newServiceTimeList,
    login_accountCategory,
    purchaseServiceFormOrder_buyServiceForm,
    testPaper_sundryErrorQuestionCount,
    testPaper_sundryErrorQuestionList,
    testPaper_removeErrorQuestion,
    upload_url,
    opinion_submit,
    questions_studentReply,
    questions_answerQuestionsReplyList,
    testPaper_sundryCollQuestionCount,
    testPaper_sundryCollQuestionList,
    temporaryStorageSub_url,
    temporaryStorage_url,
    answerAnalysisSub_url,
    answerAnalysis_url,
    testPaper_testQuestionCacheSub,
    testPaper_selectTestQuestionCache,
    questionComment_sub,
    questionComment_index,
    questionErrorCorrection_sub,
    questionNote_sub,
    questionNote_index,
    testPaper_appExercisesList,
    testPaper_appTestExercisesList,
    testPaper_newSundryCollQuestionList,
    testPaper_sundryTestErrorQuestionList,
    testPaper_newRemoveCollQuestion,
    testPaper_newRemoveErrorQuestion,
	pictures_picturesCategoryList,
	pictures_pictureList,
	vocationalExam_examGraduateStudentCategoryList,
	pcCover_getPcCoverById,
	examGraduateStudent_examGraduateStudentList,
	vocationalExam_vocationalExamCategoryList,
	vocationalExam_vocationalExamList,
	purchaseServiceFormOrder_serviceFormByOrderId,
  categoryListSon_url,
  login_selectCategory,
  HTTP_REQUEST_URL
}



// WEBPACK FOOTER //
// ./src/assets/utils/common.js